// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
// normalize CSS across browsers
import "./src/css/normalize.css"

// custom CSS styles
//import "./src/css/style.css"
import "./src/css/general-css.css"
import "./src/css/seedx-header-css.css"
import "./src/css/seedx-footer-css.css"

import "./static/utm_form-1.2.0.js"

// --- DS360: add/remove on client-side route changes ---
const EXCLUDED_PREFIXES = [
  "/careers",
  "/terms",
  "/terms-and-conditions",
  "/policy",
  "/privacy-policy",
];

const norm = (p) => (p || "/").replace(/\/+$/, "").toLowerCase();
const isExcluded = (pathname) =>
  EXCLUDED_PREFIXES.some((prefix) => norm(pathname).startsWith(norm(prefix)));

const ensureDs360Present = () => {
  // ensure config set before script
  if (!window.t_code) window.t_code = "DS-15183-3920-982";

  let inline = document.getElementById("ds360-inline");
  if (!inline) {
    inline = document.createElement("script");
    inline.id = "ds360-inline";
    inline.innerHTML = 'var t_code = "DS-15183-3920-982";';
    document.head.appendChild(inline);
  }

  let src = document.getElementById("ds360-src");
  if (!src) {
    src = document.createElement("script");
    src.id = "ds360-src";
    src.async = true;
    src.src = "//ds360.co/track/script.js"; // or "https://ds360.co/track/script.js"
    document.head.appendChild(src);
  }
};

const removeDs360 = () => {
  ["ds360-src", "ds360-inline"].forEach((id) => {
    const el = document.getElementById(id);
    if (el && el.parentNode) el.parentNode.removeChild(el);
  });
  try {
    delete window.t_code;
  } catch {
    window.t_code = undefined;
  }
};

export const onRouteUpdate = ({ location }) => {
  if (isExcluded(location?.pathname)) {
    removeDs360();
  } else {
    ensureDs360Present();
  }
};
